module.exports = __webpack_public_path__ + "static/media/29BDOS27.5e8aee02.jpg";